import { render, staticRenderFns } from "./LightBlueTextBtn.vue?vue&type=template&id=461563ef&scoped=true"
import script from "./LightBlueTextBtn.vue?vue&type=script&lang=js"
export * from "./LightBlueTextBtn.vue?vue&type=script&lang=js"
import style0 from "./LightBlueTextBtn.vue?vue&type=style&index=0&id=461563ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461563ef",
  null
  
)

export default component.exports